import { Dialog, Transition } from '@headlessui/react';
import { Dispatch, Fragment, SetStateAction, useEffect, useState } from 'react';
import { isSafari } from '../../../../../utils';

export const VideoModal = ({
  openModal,
  setOpenModal,
  isSettingsHelp
}: {
  openModal: boolean;
  setOpenModal: any;
  isSettingsHelp?: boolean;
}) => {
  const isSafariBrowser = isSafari();

  const closeIcon = () => {
    setOpenModal(false);
  };

  return (
    <Transition.Root show={openModal} as={Fragment}>
      <Dialog as="div" className="relative z-10" data-testid="modal-root" onClose={() => false}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0">
          <div className="fixed inset-0 bg-white/80 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-50 overflow-auto font-montserrat">
          <div
            className={`${
              (window.outerWidth <= 820 || window.innerWidth <= 820) && isSafariBrowser
                ? 'overflow-auto'
                : ''
            } flex items-end justify-center p-4 text-center sm:items-center 2xl:min-h-full 2xl:-mt-16 mt-24`}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
              <Dialog.Panel className="2xl:w-6/12 w-[54%] max-w-[685px] min-w-[640px] relative transform overflow-hidden rounded-[25px] bg-white text-left transition-all shadow-[0_5px_30px_-1px_rgba(0,0,0,0.25)]">
                <div className="flex flex-col font-montserrat mx-12">
                  <div className="cursor-pointer -mr-4 flex justify-end mt-5">
                    <img
                      src="/icons/cancel.svg"
                      alt="Cancel icon"
                      className="h-4"
                      onClick={closeIcon}
                    />
                  </div>

                  <div className="pb-20 pt-4">
                    <video width="600" controls>
                      <source
                        src={`/video/${isSettingsHelp ? 'settings_help' : 'headers_errors'}.mp4`}
                        type="video/mp4"
                      />
                      Your browser does not support the video tag.
                    </video>
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
};
